import { RouteConfig } from '@/types'

import Home from '@/views/Home.vue'
import RegisterThanksYou from '@/views/RegisterThankYou.vue'
import Registration from '@/views/Registration.vue'

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      icon: 'home',
      label: 'Home',
      title: 'Home',
      description: 'Home',
      layout: 'LandingLayout',
      private: false,
    },
  },
  {
    path: '/registration',
    name: 'registration',
    component: Registration,
    meta: {
      icon: 'home',
      label: 'Registration',
      title: 'Registration',
      description: 'Registration',
      layout: 'LandingLayout',
      private: false,
    },
  },
  {
    path: '/thank-you',
    name: 'register-thank-you',
    component: RegisterThanksYou,
    meta: {
      icon: '',
      label: 'Thank you',
      title: 'Thank you',
      description: 'Thank you',
      layout: 'LandingLayout',
      private: false,
    },
  }
]

export default routes
